var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 9.7998V12.5998C20.9994 14.085 20.4094 15.5094 19.3592 16.5596C18.309 17.6098 16.8846 18.1998 15.3994 18.1998H13.7586L11.2862 20.6736C11.6782 20.8822 12.1248 20.9998 12.5994 20.9998H15.3994L19.5994 25.1998V20.9998H22.3994C23.142 20.9998 23.8542 20.7048 24.3793 20.1797C24.9044 19.6546 25.1994 18.9424 25.1994 18.1998V12.5998C25.1994 11.8572 24.9044 11.145 24.3793 10.6199C23.8542 10.0948 23.142 9.7998 22.3994 9.7998H20.9994Z",
    fill: "#799AD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 7.0002C2.80005 6.25759 3.09505 5.5454 3.62015 5.0203C4.14525 4.49519 4.85744 4.2002 5.60005 4.2002H15.4C16.1427 4.2002 16.8548 4.49519 17.3799 5.0203C17.905 5.5454 18.2 6.25759 18.2 7.0002V12.6002C18.2 13.3428 17.905 14.055 17.3799 14.5801C16.8548 15.1052 16.1427 15.4002 15.4 15.4002H12.6L8.40005 19.6002V15.4002H5.60005C4.85744 15.4002 4.14525 15.1052 3.62015 14.5801C3.09505 14.055 2.80005 13.3428 2.80005 12.6002V7.0002Z",
    fill: "#317BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.afc956f74c1dcc244d330f7282542799.svg";
export { ForwardRef as ReactComponent };